import React from "react";
import { COPY_RIGHT } from "../../../../helpers/constants";
import { getTrueClasses } from "../../../../helpers";

const EU = ({ mobile }) => {
  const { ADDRESSES } = COPY_RIGHT;

  return (
    <div className={getTrueClasses("GCL-F-B-EU", mobile && "GCL-F-B-EU_mob")}>
      <p>{ADDRESSES.PHILADELPHIA}</p>
      <p>{ADDRESSES.DUBAI}</p>
    </div>
  );
};
export default EU;
